"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("../datapoints");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Check_1 = require("office-ui-fabric-react/lib/components/Check");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var owa_analytics_1 = require("owa-analytics");
var owa_analytics_2 = require("owa-analytics");
var owa_favorites_1 = require("owa-favorites");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var owa_mail_favorites_store_2 = require("owa-mail-favorites-store");
var MailListFilter_1 = require("owa-mail-list-filter-view/lib/components/MailListFilter");
var owa_mail_list_selection_orchestrator_1 = require("owa-mail-list-selection-orchestrator");
var getSelectedTableView_1 = require("owa-mail-list-store/lib/utils/getSelectedTableView");
var owa_mail_message_actions_1 = require("owa-mail-message-actions");
var owa_people_persona_header_first_run_view_1 = require("owa-people-persona-header-first-run-view");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var store_1 = require("owa-recipient-cache/lib/store/store");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var ReadingPanePosition_1 = require("owa-session-store/lib/store/schema/ReadingPanePosition");
var owa_people_strings_1 = require("owa-strings/owa-people-strings");
var React = require("react");
var PersonaCardBehavior_1 = require("owa-persona/lib/components/PersonaCardBehavior");
var favoritesBitFlagsActions_1 = require("owa-mail-favorites-store/lib/actions/helpers/favoritesBitFlagsActions");
var viewFiltersForMailFolderNode = ['All', 'Unread', 'ToOrCcMe', 'Flagged'];
var styles = require('./PersonaHeader.scss');
var classNames = require('classnames/bind').bind(styles);
var PersonaHeader = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaHeader, _super);
    function PersonaHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCheckAll = function (tableView) {
            // PersonaHeader could be loaded independent of list view in PhotoHub,
            // so we need to check if tableView is null
            var isInCheckedMode = tableView && tableView.isInCheckedMode;
            var isListViewEmpty = tableView && tableView.rowKeys.length == 0;
            var isReadingPanePositionOff = getUserConfiguration_1.default().UserOptions.GlobalReadingPanePositionReact ==
                ReadingPanePosition_1.default.Off;
            var checkBoxClassNames = classNames(isReadingPanePositionOff ? styles.checkBoxSingleLine : styles.checkBoxThreeColumn, isInCheckedMode && styles.showCheckbox, !isListViewEmpty && styles.listViewHasItems);
            return (React.createElement("div", { className: checkBoxClassNames, onClick: isListViewEmpty ? null : function () { return owa_mail_list_selection_orchestrator_1.MailListSelection.toggleCheckAll(tableView); } }, React.createElement(Check_1.Check, { checked: isInCheckedMode })));
        };
        _this.handleEmailClick = function (ev) {
            owa_analytics_1.logUsage(owa_mail_message_actions_1.datapoints.MailComposeFromHeader.datapoint.name);
            if (_this.props.composeEmailClick) {
                _this.props.composeEmailClick();
            }
            else {
                owa_mail_message_actions_1.lazyNewMessage.importAndExecute('PersonaHeader', null /*groupId*/, _this.props.personEmail, _this.props.personName, true);
            }
        };
        _this.toggleFavoriteState = function (evt) {
            evt.stopPropagation();
            _this.toggleFavoritePersona();
        };
        return _this;
    }
    PersonaHeader.prototype.render = function () {
        var personEmail = this.props.personEmail;
        var titleText = this.props.personNameDisplayOverride || this.props.personName;
        var isPersonFavorite = owa_mail_favorites_store_2.isPersonaInFavorites(this.props.personId, personEmail);
        var tableView = getSelectedTableView_1.default();
        return (React.createElement("div", { className: styles.headerContainer },
            React.createElement("div", { className: styles.imageAndInfoContainer },
                this.getImageControl(),
                this.getPersonInfo(titleText)),
            this.getHeaderButtons(tableView, isPersonFavorite),
            this.showPersonaHeaderFirstRunExperience()));
    };
    PersonaHeader.prototype.componentDidMount = function () {
        this.logHeaderRendered();
    };
    PersonaHeader.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.personId !== prevProps.personId ||
            this.props.favoriteActionSource !== prevProps.favoriteActionSource) {
            this.logHeaderRendered();
        }
    };
    PersonaHeader.prototype.shouldShowPersonaHeaderFirstRun = function () {
        if (!store_1.default.recipientCache) {
            return false;
        }
        // Show the persona header first run experience only once
        if (favoritesBitFlagsActions_1.getIsBitEnabled(4 /* PersonaHeaderFirstRunSeen */)) {
            return false;
        }
        // If the header was displayed from the search
        if (this.props.favoriteActionSource !== 'PersonaHeaderFromFolderSearch' &&
            this.props.favoriteActionSource !== 'PersonaHeaderFromPersonaSearch') {
            return false;
        }
        // If the user doesn't have any persona favorites
        if (owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.size > 0) {
            return false;
        }
        if (!this.props.personEmail) {
            return false;
        }
        var personEmailLowerCase = this.props.personEmail.toLowerCase();
        // If the displayed persona is within the top 100 people returned from findPeople (rcStore.recipientCache is sorted)
        return store_1.default.recipientCache
            .slice(0, 100)
            .some(function (persona) {
            return persona.EmailAddresses.some(function (emailAddress) {
                return (emailAddress.OriginalDisplayName &&
                    emailAddress.OriginalDisplayName.toLowerCase() ===
                        personEmailLowerCase) ||
                    (emailAddress.EmailAddress &&
                        emailAddress.EmailAddress.toLowerCase() === personEmailLowerCase);
            });
        });
    };
    PersonaHeader.prototype.getImageControl = function () {
        return (React.createElement("div", null,
            React.createElement(LPCWrapper, { emailAddress: this.props.personEmail, name: this.props.personName, composeEmailOverride: this.props.composeEmailClick, personaType: 'User' },
                React.createElement(PersonaControl_1.default, { emailAddress: this.props.personEmail, name: this.props.personName, size: Persona_1.PersonaSize.regular }))));
    };
    PersonaHeader.prototype.getPersonInfo = function (titleText) {
        return (React.createElement("div", { className: styles.personInfoContainer },
            React.createElement(LPCWrapper, { emailAddress: this.props.personEmail, name: this.props.personName, composeEmailOverride: this.props.composeEmailClick, personaType: 'User' },
                React.createElement("div", { className: styles.personName }, titleText),
                React.createElement("div", { className: styles.personEmail }, this.props.personEmail))));
    };
    PersonaHeader.prototype.showPersonaHeaderFirstRunExperience = function () {
        if (this.toggleFavoriteDiv && this.shouldShowPersonaHeaderFirstRun()) {
            return React.createElement(owa_people_persona_header_first_run_view_1.PersonaHeaderFirstRun, { target: this.toggleFavoriteDiv });
        }
        return null;
    };
    PersonaHeader.prototype.getHeaderButtons = function (tableView, isPersonaFavorite) {
        var _this = this;
        var controlsContainerClassNames = classNames(styles.controlsContainer, this.props.hideCheckAll && styles.noCheckbox);
        var buttonWrapperClassName = this.props.hideCheckAll
            ? styles.wideButtonsWrapper
            : styles.buttonsWrapper;
        var buttonStyles = {
            root: styles.button,
        };
        return (React.createElement("div", { className: controlsContainerClassNames },
            !this.props.hideCheckAll && this.renderCheckAll(tableView),
            React.createElement("div", { className: buttonWrapperClassName },
                React.createElement(Button_1.ActionButton, { iconProps: {
                        iconName: "Mail" /* Mail */,
                        styles: {
                            root: styles.mailIcon,
                        },
                    }, styles: buttonStyles, text: owa_people_strings_1.default.emailButtonLabel, onClick: this.handleEmailClick }),
                React.createElement("div", { ref: function (ref) { return (_this.toggleFavoriteDiv = ref); } },
                    React.createElement(owa_favorites_1.ToggleFavoriteButton, { isWrappedInAnotherButton: true, isInFavorites: isPersonaFavorite, className: styles.favoriteButtonWrapper, onClick: this.toggleFavoriteState, animate: true, text: owa_people_strings_1.default.favoriteButtonLabel, styles: buttonStyles, isClickDisabled: !owa_mail_favorites_store_1.favoritesStore.isFavoritePersonasChangeable }))),
            this.props.hideFilter ? null : (React.createElement("div", { className: styles.filterWrapper },
                React.createElement(MailListFilter_1.default, { supportedViewFilters: viewFiltersForMailFolderNode, containerClassName: styles.mailFilterContainer, filterMenuSource: 'PeopleFilterMenu', tableViewId: tableView.id })))));
    };
    PersonaHeader.prototype.toggleFavoritePersona = function (isRetry) {
        var _this = this;
        owa_mail_favorites_store_2.lazyToggleFavoritePersona
            .importAndExecute(this.props.personId, this.props.personEmail, this.props.personName, isRetry ? 'NotificationActionClick' : this.props.favoriteActionSource)
            .catch(function (e) {
            return owa_mail_favorites_store_2.lazyHandleToggleFavoritePersonaError.importAndExecute(e, function () {
                return _this.toggleFavoritePersona(true);
            });
        });
    };
    PersonaHeader.prototype.logHeaderRendered = function () {
        var eventName = datapoints_1.default.PersonaHeaderShown.datapoint.name;
        owa_analytics_1.logUsage(eventName, [this.props.favoriteActionSource]);
    };
    PersonaHeader = tslib_1.__decorate([
        owa_analytics_2.logMountingPerformance('PersonaHeader'),
        mobx_react_1.observer
    ], PersonaHeader);
    return PersonaHeader;
}(React.Component));
exports.default = PersonaHeader;
var LPCWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LPCWrapper, _super);
    function LPCWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPCWrapper.prototype.render = function () {
        return (React.createElement("div", { onClick: this.props.onPersonaCardBehaviorClick, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave }, this.props.children));
    };
    LPCWrapper = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior
    ], LPCWrapper);
    return LPCWrapper;
}(React.Component));
//# sourceMappingURL=PersonaHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/people/owa-people-persona-header-view/lib/components/PersonaHeader.js
// module id = 5973
// module chunks = 46